import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "typeface-poppins";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("kt_body"));
